<template>
  <div class="contact-container">
      <div class="contact-content" 
        :style="'backgroundImage: url('+row.image7+')'">
        <div class="overlay text-center">
            <div class="bg-title white-color mb-5" v-html="row.title7"></div>
            <div class="search-box d-flex justify-content-center">
                <input type="text" v-model="email" placeholder="Your mail here " />
                <button @click="newsletter" class="subscribe-btn d-inline-block">
                    <div class="d-flex align-items-center">{{ row.button7 }} <span class="icon-back"></span></div>
                </button>
            </div>
            <div v-if="success" style="color: #080" class="alert-msg mt-1">email sent successfully.</div>
            <div v-if="error" style="color: #f00" class="alert-msg mt-1">this email not valid.</div>
        </div>
      </div>
  </div>
</template>

<style scoped>
.contact-container {
  margin-bottom: 0.7rem;
}
.contact-content {
  background-size: cover;
  position: relative;
}
.overlay {
  padding: 95px 0;
  position: static;
  background: rgba(0, 0, 0, 0.6);
}
.search-box input {
    background: #fff;
    padding: 7px 17px;
    min-width: 320px;
}
.subscribe-btn {
    background: #fff;
    padding: 7px 17px;
    margin-left: 3px;
    color: #6e6d76;
}
.subscribe-btn:hover {
    background: #0020A5;
    color: #fff;
}
.subscribe-btn:active {
    opacity: 0.6;
}
.subscribe-btn:hover .icon-back:before {
    color: #fff;
}
.icon-back {
    font-weight: bold;
}
/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
    
}

@media (max-width: 767.98px) {
  .search-box input {
    min-width: 179px;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {
  .search-box input {
    min-width: 280px;
  }
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {

}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {

}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {

}
</style>

<script>
import axios from 'axios';

export default {
  name: "Section5",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
      email: '',
      error: false,
      success: false
    };
  },
  created() {
      //
  },
  methods: {
    //
    newsletter() {
      const options = {
        url: window.baseURL + '/newsletters',
        method: "POST",
        data: {
          email: this.email
        },
      };

      axios(options)
        .then((res) => {
          console.log(res);
          this.email = "";
          this.success = true;
          this.error = false;
        })
        .catch((err) => {
          console.log(err)
          this.success = false;
          this.error = true;
        });
    }
  },
};
</script>
